import { getQueryStringParameter } from 'owa-querystring';

const GETSTARTED_POSITION_OVERRIDE_PARAMETER_NAME = 'getStartedPosition';

export function getGetStartedPositionOverride(): string {
    return getQueryStringParameter(GETSTARTED_POSITION_OVERRIDE_PARAMETER_NAME);
}
